/**
 * 表紙特集掲載商品選定（CX）画面の商品部への選定依頼一覧クラス
 *
 * @export SelectionRequestInfo
 * @class SelectionRequestInfo
 */
export class SelectionRequestInfo {
  constructor(
    // チェックボックス
    public check: boolean = false,
    // バイヤー選定依頼ID
    public buyerRequestId: string = null,
    // 特集コード
    public featureCode: string = null,
    // 特集名
    public featureName: string = null,
    // フォーマット特集
    public formatFeature: string = null,
    // 部門コード
    public classCode: string = null,
    // 部門名
    public classNameKanji: string = null,
    // フォーマット部門
    public formatClass: string = null,
    // 中分類コード
    public middleClassCode: string = null,
    // 中分類名
    public middleClassNameKanji: string = null,
    // フォーマット中分類
    public formatMiddleClass: string = null,
    // Pコード
    public pCode: string = null,
    // 商品名(商品案内用商品名)
    public guideGoodsName: string = null,
    // 規格名(商品案内用規格名)
    public guideStandardName: string = null,
    // 価格パターン
    public pricePattern: string = null,
    // 今回供給価格
    public thisTimeSupplyPrice: string = null,
    // 供給価格（通常）
    public supplyPriceStandard: string = null,
    // 供給価格（特価1）
    public supplyPriceSpecial1: string = null,
    // 供給価格（特価2）
    public supplyPriceSpecial2: string = null,
    // 仕入価(今回仕入価格)
    public thisTimeCostPrice: string = null,
    // 単品仕入価格（通常）
    public costPriceStandard: string = null,
    // 単品仕入価格（特価1）
    public costPriceSpecial1: string = null,
    // 単品仕入価格（特価2）
    public costPriceSpecial2: string = null,
    // 計画数
    public planNum: string = null,
    // 計画供給高
    public planSupplyBudget: string = null,
    // GPR
    public gpr: string = null,
    // 依頼ステータス
    public requestStatus: string = null,
    // 依頼ステータス名称
    public requestStatusName: string = null,
    // 備考
    public remarks: string = null,
  ) {}
}
